import React, { useState, useEffect, useMemo } from "react";
import { database } from "../../database/firebase";
import { Header } from "../../components";
import Table, { SelectColumnFilter } from "../../components/Table";

import QRCode from 'qrcode.react';
const extractAddress = (place) => {

    const address = {
        city: "",
        state: "",
        zip: "",
        country: "",
        plain() {
            const city = this.city ? this.city + ", " : "";
            const zip = this.zip ? this.zip + ", " : "";
            const state = this.state ? this.state + ", " : "";
            return city + zip + state + this.country;
        }
    }

    if (!Array.isArray(place?.address_components)) {
        return address;
    }

    place.address_components.forEach(component => {
        const types = component.types;
        const value = component.long_name;

        if (types.includes("locality")) {
            address.city = value;
        }

        if (types.includes("administrative_area_level_2")) {
            address.state = value;
        }

        if (types.includes("postal_code")) {
            address.zip = value;
        }

        if (types.includes("country")) {
            address.country = value;
        }

    });

    return address;
}
function CatchHistory() {
    const [catchInfo, setCatchInfo] = useState([]);
    const [catchCell, setCatchCell] = useState([]);
    const [catchId, setCatchId] = useState("");
    const [fisherInfo, setfisherInfo] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [emailAccessObj, setEmailAccessObj] = useState();
    //const [emailAccessSelected, setEmailAccessSelected] = useState();
    const [subAccountData, setSubAccountData] = useState();
    const [showSub, setShowSub] = useState(false);

    const apiKey = "AIzaSyAzI0qgeBeJsRj2eQSGLbJAn8xij5Dd_gQ";
    //const mapApiJs = 'https://maps.googleapis.com/maps/api/js';
    const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';

    const [address, setAddress] = useState({
        state: "",
    });

    // const [loc, setLoc] = useState({
    //   lng: "",
    //   lag: ""
    // });

    // const {
    //   lng,
    //   lat
    // } = loc;

    useEffect(() => {
        //console.log("History");
        let uid = localStorage.getItem("uid");
        let userUid = JSON.parse(uid);
        const fetchEmailAccess = async () => {

            database.child(`users/${userUid}/emailAccess`).once("value", (snap) => {
                const emailAccessArray = snap.val();
                if (emailAccessArray !== null || emailAccessArray !== undefined) {
                    setEmailAccessObj(emailAccessArray)
                } else {
                    setEmailAccessObj(null)
                }
            })
        }
        fetchEmailAccess();
    }, []);


    const fetchCatch = async (userUid) => {

        database.child(`users/${userUid}/catch`).orderByChild('timestamp').limitToLast(100).once("value", (snap) => {
            let catchRes = snap.val();
            setCatchCell([catchRes]);
            for (var key in catchRes) {
                setCatchInfo(prevArray => [...prevArray, catchRes[key]])
            }
            //console.log(catchInfo);
        });
        database.child(`users/${userUid}/userfisher`).once("value", (snap) => {
            let fisherRes = snap.val();
            setfisherInfo([fisherRes]);
            // for (var key in fisherRes) {
            //   setfisherInfo(prevArray => [...prevArray, fisherRes[key]])
            // }
        });
    }

    const showCard = (val) => {
        setShowModal(true);
        setCatchId(val);
    };

    const getEmailAccessData = (val) => {
        console.log(val)
        database.child(`users/${val}`).once("value", (snap) => {
            console.log(snap.val())
            setSubAccountData(snap.val())
        })
        setShowSub(true)
    }

    const resetEmailAccess = (val) => {
        setCatchCell("");
        setCatchInfo("");
        setfisherInfo("");

        fetchCatch(val);
    }

    const reverseGeocode = (lng, lat) => {
        const url = `${geocodeJson}?key=${apiKey}&latlng=${lat},${lng}`;

        fetch(url)
            .then(response => response.json())
            .then(location => {
                const place = location.results[0];
                const _address = extractAddress(place);
                console.log(_address);
                setAddress(
                    { "state": _address.city });
            }).then(catchQR)

    }

    const generateQR = () => {
        reverseGeocode(parseFloat(catchCell['0'][catchId].longitude), parseFloat(catchCell['0'][catchId].latitude))
    }

    const catchQR = () => {
        // let catchQRInfo = {
        //   itemName: catchCell['0'][catchId].species, //note this
        //   itemCode: catchCell['0'][catchId].id,
        //   stock: catchCell['0'][catchId].weight,
        //   imgURL: catchCell['0'][catchId].src
        // }
        // console.log(catchQRInfo);

        const canvas = document.getElementById("fisherQR");
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/octet-stream", "image/png");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = catchCell['0'][catchId].id + '.png';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    const setTimestamp = ({ value }) => {
        let date = new Date(value);
        var year = date.getFullYear();
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var month = months[date.getMonth()];
        var day = date.getDate();
        // var hours = date.getHours();
        // var minutes = "0" + date.getMinutes();
        // var seconds = "0" + date.getSeconds();
        // var time = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
        var timedate = month + " " + day + ", " + year;

        return timedate;
    }



    const columns = useMemo(
        () => [
            {

                Header: "Timestamp",
                accessor: "timestamp",
                Cell: setTimestamp,
            },
            {
                Header: "Species",
                accessor: "species",
                id: "fishspecies", //added this
                Filter: SelectColumnFilter,  // new
                filter: 'includes',  // new
            },

            {
                Header: "Weight",
                accessor: "weight",
            },
            {
                Header: "Location",
                accessor: "longitude",

            },
            {
                Header: "Action",
                accessor: "id",
                Cell: ({ cell }) => (
                    <button value={cell.value}
                        className=" w-full bg-blue-600 text-white text-sm font-regular py-1 px-6 rounded-lg shadow-md hover:bg-yellow-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-purple-200"
                        onClick={e => showCard(e.target.value)}>
                        View
                    </button>
                )
            },

        ],
        []
    );


    const data = useMemo(() => catchInfo);
    //here just straight get the state array

    return (
        <>
            <div className="md:flex">
                <aside class="md:h-screen md:sticky md:top-0">
                    <Header />
                </aside>

                {showSub && subAccountData ? (
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-auto my-6 mx-auto max-w-max">

                                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                        <p className="text-medium  font-normal pr-10 text-black-900">
                                            Admin ID: {subAccountData.uid}
                                        </p>

                                        <button
                                            className="p-1 ml-auto  border-0 text-black-900 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                            onClick={() => setShowSub(false)}
                                        >
                                            <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                ×
                                            </span>
                                        </button>
                                    </div>
                                    {/*body*/}
                                    <div className="sm:flex justify-between">

                                        <div className="p-5 mx-5">

                                            <p className="text-lg text-gray-500 font-sans font-normal">
                                                Username</p>
                                            <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                {subAccountData.username}</p>
                                            <p className="text-lg text-gray-500 font-sans font-normal">
                                                Email</p>
                                            <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                {subAccountData.email}</p>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}

                <div className="flex flex-col">
                    <div className="flex w-full justify-between h-14  mt-20 md:ml-5">
                        <div className="text-4xl mb-10 text-blue-700 font-sans font-bold">
                            Seafood Catch Records
                        </div>
                    </div>

                    <div className="flex">
                        <div className="max-width m-auto p-5 text-gray-900" >
                            {showModal && catchCell['0'][catchId].src ?
                                <>
                                    <div
                                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                                    >
                                        <div className="relative w-auto my-6 mx-auto max-w-max">
                                            {/*content*/}
                                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                                {/*header*/}
                                                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                                    <p className="text-lg font-normal">
                                                        Control Number: {catchCell['0'][catchId].id}
                                                    </p>

                                                    <button
                                                        className="p-1 ml-auto  border-0 text-black-900 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                                        onClick={() => setShowModal(false)}
                                                    >
                                                        <span className="text-black-900  h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                            ×
                                                        </span>
                                                    </button>
                                                </div>
                                                {/*body*/}
                                                {
                                                    catchCell['0'][catchId].src ? <>
                                                        <div className="sm:flex justify-between">

                                                            <div className="mx-10 my-5">
                                                                <img src={catchCell['0'][catchId].src} width="200px" alt="catch"></img>
                                                            </div>
                                                            <div className="p-5 mx-5">
                                                                <p className="text-xl text-blue-700 font-sans font-light mb-5">
                                                                    Catch Info</p>
                                                                {catchCell['0'][catchId].byCatch ?
                                                                    <>
                                                                        <p className="text-lg text-gray-500 font-sans font-normal">
                                                                            Species</p>
                                                                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                                            {catchCell['0'][catchId].byCatch}</p>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <p className="text-lg text-gray-500 font-sans font-normal">
                                                                            Species</p>
                                                                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                                            {catchCell['0'][catchId].species}</p>
                                                                    </>
                                                                }


                                                                <p className="text-lg text-gray-500 font-sans font-normal">
                                                                    Weight</p>
                                                                <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                                    {catchCell['0'][catchId].weight} kg</p>
                                                                <p className="text-lg  text-gray-500 font-sans font-normal">
                                                                    Location</p>
                                                                {catchCell['0'][catchId].geoLocation ?
                                                                    <>
                                                                        <p className="text-xl text-gray-500 font-sans font-semibold">
                                                                            {catchCell['0'][catchId].geoLocation.city}, {catchCell['0'][catchId].geoLocation.province}
                                                                        </p>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <p className="text-xl text-gray-500 font-sans font-semibold">
                                                                            {parseFloat(catchCell['0'][catchId].longitude).toFixed(2)}, {parseFloat(catchCell['0'][catchId].latitude).toFixed(2)}</p>
                                                                    </>
                                                                }
                                                            </div>

                                                            {fisherInfo['0'][catchCell['0'][catchId].fisherUid] ?
                                                                <>
                                                                    <div className="p-5 mx-5">
                                                                        <p className="text-xl text-blue-700 font-sans font-light mb-5">
                                                                            Fisherman Info</p>
                                                                        <p className="text-lg text-gray-500 font-sans font-normal">
                                                                            Name</p>
                                                                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                                            {fisherInfo['0'][catchCell['0'][catchId].fisherUid].lastName}, {fisherInfo['0'][catchCell['0'][catchId].fisherUid].firstName}</p>
                                                                        <p className="text-lg text-gray-500 font-sans font-normal">
                                                                            Vessel No.</p>
                                                                        <p className="text-2xl pb-5 text-gray-500 font-sans font-extrabold">
                                                                            {fisherInfo['0'][catchCell['0'][catchId].fisherUid].vesselNum}</p>
                                                                        <p className="text-lg text-gray-500 font-sans font-normal">
                                                                            Contact No.</p>
                                                                        <p className="text-2xl text-gray-500 font-sans font-extrabold">
                                                                            {fisherInfo['0'][catchCell['0'][catchId].fisherUid].mobileNum}</p>
                                                                    </div>
                                                                </> : <><div className="p-6 text-red-600"> Fisherman record deleted.</div></>}

                                                            <div className="opacity-10">
                                                                {catchCell['0'][catchId].byCatch ?
                                                                    <>
                                                                        <QRCode
                                                                            id='fisherQR'
                                                                            value={JSON.stringify({
                                                                                itemName: catchCell['0'][catchId].byCatch, //note this
                                                                                itemCode: catchCell['0'][catchId].id,
                                                                                weight: catchCell['0'][catchId].weight,
                                                                                location: address.state,
                                                                                imgURL: catchCell['0'][catchId].src
                                                                            })}
                                                                            size={220}
                                                                            level={"L"}
                                                                            includeMargin={true}
                                                                            fgColor={"#1e3a8a"}
                                                                        />
                                                                    </> :
                                                                    <>
                                                                        <QRCode
                                                                            id='fisherQR'
                                                                            value={JSON.stringify({
                                                                                itemName: catchCell['0'][catchId].species, //note this
                                                                                itemCode: catchCell['0'][catchId].id,
                                                                                weight: catchCell['0'][catchId].weight,
                                                                                location: address.state,
                                                                                imgURL: catchCell['0'][catchId].src
                                                                            })}
                                                                            size={220}
                                                                            level={"L"}
                                                                            includeMargin={true}
                                                                            fgColor={"#1e3a8a"}
                                                                        />
                                                                    </>}
                                                            </div>
                                                        </div>
                                                    </>
                                                        : <>
                                                            <div className="sm:flex justify-between">
                                                                <div className="mx-10 my-5 text-gray-800 text-sm">
                                                                    Loading...
                                                                </div> </div>
                                                        </>
                                                }


                                                {/*footer*/}
                                                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                                    <button
                                                        className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                                        type="button"
                                                        onClick={() => setShowModal(false)}
                                                    >
                                                        Close
                                                    </button>
                                                    <button
                                                        className="bg-blue-600 uppercase text-white active:bg-emerald-600 text-sm px-6 py-3 rounded shadow hover:bg-blue-700"
                                                        type="button"
                                                        onClick={generateQR}
                                                    >
                                                        Generate QR
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                                </> :
                                null
                            }

                            <div className="flex flex-col sm:flex-row">
                                {emailAccessObj === undefined || null ?
                                    <></> : <>
                                        <div className="flex">
                                            <div className="flex flex-col">
                                                <div className="text-gray-600 font-light">
                                                    Account Access
                                                </div>
                                                <div className="flex flex-row justify-between">

                                                    {emailAccessObj === null ?
                                                        <>
                                                            <div className="mr-4 py-2">
                                                                No Email Access Data
                                                            </div>
                                                        </> :
                                                        <>
                                                            <div className="mr-4 py-2">
                                                                {Object.values(emailAccessObj).map((email, i) => (
                                                                    <>
                                                                        <div classname="flex flex-row my-2">
                                                                            <p>
                                                                                {email.email}
                                                                            </p>

                                                                            <button
                                                                                className="text-white text-xs bg-blue-600 py-1 px-4 mr-2 rounded-lg hover:bg-blue-700"
                                                                                onClick={() => resetEmailAccess(email.accessUid)}>
                                                                                View Catch
                                                                            </button>
                                                                            <button
                                                                                className="text-blue-600 text-xs border border-blue-600 my-2 py-1 px-4 rounded-lg hover:text-white hover:bg-blue-700"
                                                                                onClick={() => getEmailAccessData(email.accessUid)}>
                                                                                View Account
                                                                            </button>
                                                                        </div>

                                                                    </>
                                                                ))}
                                                            </div>
                                                        </>}

                                                </div>
                                            </div>

                                        </div></>}

                                <div className="rounded-xl bg-white shadow-2xl sm:p-10">

                                    {catchInfo == [] ?
                                        <div>Loading...</div>
                                        :
                                        <Table
                                            columns={columns}
                                            data={data}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default CatchHistory;